module.exports = __webpack_public_path__ + "static/media/credit_card_payment_amber.30acdf6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/credit_card_payment_amber.svg
// module id = 1090
// module chunks = 2